/* =================================================================
   RANI MOBILYA — Card Gallery JS
   - Desktop: mouse pozisyonuna göre görsel değişimi (hover gallery)
   - Mobile: native CSS scroll-snap touch swipe (JS sadece dot sync)
   - Dot indicator senkronize
   ================================================================= */
(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 900;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function syncDots(gallery, activeIndex) {
    var dots = gallery.querySelectorAll('[data-rani-gallery-dot]');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === activeIndex);
    });
  }

  function scrollToIndex(track, index, smooth) {
    var slideWidth = track.clientWidth;
    track.scrollTo({
      left: index * slideWidth,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-rani-gallery-track]');
    if (!track) return;
    var count = parseInt(gallery.getAttribute('data-count') || '0', 10);
    if (count < 2) return;

    var currentIndex = 0;

    // Scroll event ile dot senkronizasyonu (mobile swipe için)
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var newIndex = Math.round(track.scrollLeft / track.clientWidth);
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          syncDots(gallery, currentIndex);
        }
      }, 50);
    }, { passive: true });

    // Desktop hover: mouse pozisyonuna göre görsel değişimi
    if (isDesktop()) {
      gallery.addEventListener('mousemove', function (e) {
        if (!isDesktop()) return;
        var rect = gallery.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var ratio = Math.max(0, Math.min(1, x / rect.width));
        var newIndex = Math.min(count - 1, Math.floor(ratio * count));
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          scrollToIndex(track, newIndex, false);
          syncDots(gallery, currentIndex);
        }
      });

      gallery.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        currentIndex = 0;
        scrollToIndex(track, 0, true);
        syncDots(gallery, 0);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-rani-gallery]').forEach(function (gallery) {
      if (gallery.dataset.raniGalleryReady === '1') return;
      gallery.dataset.raniGalleryReady = '1';
      initGallery(gallery);
    });
  }

  // İlk yükleme
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Dinamik yüklenen kartlar için (örn: collection filter sonrası)
  var observer = new MutationObserver(function (mutations) {
    var hasNewGallery = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('[data-rani-gallery]')) hasNewGallery = true;
          else if (node.querySelector && node.querySelector('[data-rani-gallery]')) hasNewGallery = true;
        }
      });
    });
    if (hasNewGallery) initAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
